import { AD_SOURCE_ETF_OVERLAP } from "@utils/onboarding/adSource";
import { getAdSourceCookie } from "@utils/onboarding/adSourceCookie.client";
import { peekEntryIntent } from "@utils/onboarding/entryIntent.client";
import {
  probeHasHoldingsOnce,
  type HoldingsProbeClient,
} from "../api/probeHasHoldings";
import { getHoldingsProbeClient } from "../api/holdingsProbeClient";

export type OverlapSigninExtras = {
  ad_source: "etf_overlap";
  has_holdings: boolean;
};

/** 当前是否 ETF 重叠广告会话（cookie 里的归因，或尚未消费的落点意图）。 */
export function isEtfOverlapAdSession(): boolean {
  return (
    getAdSourceCookie()?.trim().toUpperCase() === AD_SOURCE_ETF_OVERLAP ||
    peekEntryIntent() === "etf_overlap"
  );
}

/**
 * `auth_signin_success` 的重叠分析补充参数（EDG-561 AC-1.5）。
 *
 * - 非重叠广告会话返回 `null`：调用方原样发，**零延迟、载荷不变**；
 * - 重叠广告会话异步补 `ad_source` / `has_holdings`。持仓用 `probeHasHoldingsOnce`，
 *   与登录后的 entry gate 共用同一个 promise（只发一次请求）；超过 3s 或失败按 `false`。
 *
 * 三个发射点（`LoginPage` / `LoginModalProvider` / `EmailLoginModal`）统一写法：
 * `const extras = resolveOverlapSigninExtras(client); extras ? void extras.then(send) : send();`
 */
export function resolveOverlapSigninExtras(
  client: HoldingsProbeClient | null | undefined = getHoldingsProbeClient(),
): Promise<OverlapSigninExtras> | null {
  if (!isEtfOverlapAdSession()) {
    return null;
  }
  return probeHasHoldingsOnce(client).then((has_holdings) => ({
    ad_source: "etf_overlap" as const,
    has_holdings,
  }));
}
